import { CreatePainPartsDto } from '#types/member';
import { atom, useRecoilState } from 'recoil';

export interface IPainPartsState extends CreatePainPartsDto {}

// 회원 사전 정보 api에 사용하는 상태
const $painPartsState = atom<IPainPartsState[]>({
  key: 'painPartsState',
  default: []
});

export const usePainPartsRecoil = () => {
  const [painParts, setPainParts] = useRecoilState($painPartsState);

  return { painParts, setPainParts };
};
